<template>
    <div id="app">
        <ion-app>
            <ion-menu-controller></ion-menu-controller>

            <app-menu></app-menu>

            <ion-vue-router id="contentMain"></ion-vue-router>
        </ion-app>
    </div>
</template>

<script>
import { Plugins } from "@capacitor/core"
import { FCM } from "capacitor-fcm"
import AppMenu from "./components/AppMenu"
import NotificationModal from "./components/NotificationModal"
import firebase from "firebase"
import intercomApiService from "./services/IntercomApi"
import { Deploy } from "cordova-plugin-ionic"


const { PushNotifications, Storage } = Plugins
const fcm = new FCM()

export default {
    name: "app",
    components: {
        "app-menu": AppMenu,
    },
    data() {
        return {
            notifications: [],
        }
    },

    async created() {
        //remove all push notification stuff on the web
        if (this.webOnly) {
            return
        }

        //check for updates
        const update = await Deploy.checkForUpdate()

        if (update.available) {
            return this.$router.push('updating')
        }

        PushNotifications.requestPermission().then((result) => {
            if (result.granted) {
                // Get token using capacitor-fcm plugin as capacitor native returns apple APNS token.
                fcm.getToken()
                    .then(async (response) => {
                        await Storage.set({
                            key: "pushToken",
                            value: response.token,
                        })
                    })
                    .catch(() => {
                        // this.handleError(
                        //     error,
                        //     "Push Notification Get Token Error"
                        // )
                    })
                PushNotifications.register()
            } else {
                // Show some error
            }
        })

        // Some issue with our setup and push will not work
        PushNotifications.addListener("registrationError", async () => {
            await Storage.remove({ key: "pushToken" })
            await Storage.remove({ key: "pushTokenSet" })
            // this.handleError(error, "Push Notification Registration Error")
        })

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener(
            "pushNotificationReceived",
            (notification) => {
                PushNotifications.removeAllDeliveredNotifications()
                this.notifications.unshift(notification)
                this.showNotification()
            }
        )

        // Method called when tapping on a notification
        PushNotifications.addListener(
            "pushNotificationActionPerformed",
            (notification) => {
                PushNotifications.removeAllDeliveredNotifications()
                this.notifications.unshift(notification.notification)
                // Show full message in a modal.
                this.showNotification()
            }
        )
    },
    computed: {
        webOnly() {
            return process.env.VUE_APP_WEB_ONLY == "true"
        },
    },

    methods: {
        showNotification() {
            this.$ionic.modalController
                .create({
                    component: NotificationModal,
                    componentProps: {
                        parent: this,
                        data: {
                            notifications: this.notifications,
                        },
                    },
                })
                .then((modal) => modal.present())
        },

        handleError(error, message) {
            this.$ionic.alertController
                .create({
                    header: message,
                    message:
                        "The app has crashed and needs to restart. Reason: " +
                        JSON.stringify(error),
                    buttons: [
                        {
                            text: "Okay",
                            handler: async () => {
                                firebase
                                    .auth()
                                    .signOut()
                                    .then(async () => {
                                        await Storage.remove({
                                            key: "pushToken",
                                        })
                                        await Storage.remove({
                                            key: "pushTokenSet",
                                        })
                                        intercomApiService.logout()
                                        this.$router.push("login")
                                    })
                            },
                        },
                    ],
                })
                .then((a) => a.present())
        },
    },
}
</script>
